import { GeoCoordinate } from '@geofences/geofence';

export function extractCoordinates(polygon: google.maps.Polygon): GeoCoordinate[] {
  const path = polygon.getPath();
  return Array.from({ length: path.getLength() }, (_, i) => {
    const p = path.getAt(i);
    return { latitude: p.lat(), longitude: p.lng() };
  });
}

export function isValidPolygon(coords: GeoCoordinate[]): boolean {
  return coords.length >= 3;
}

export function toGeoJSONRing(coords: GeoCoordinate[]): number[][] {
  const ring = coords.map((c) => [c.longitude, c.latitude]);
  if (ring.length > 0) {
    const first = ring[0];
    const last = ring[ring.length - 1];
    if (first[0] !== last[0] || first[1] !== last[1]) {
      ring.push([...first]);
    }
  }
  return ring;
}

export function fromGeoJSONRing(ring: number[][]): GeoCoordinate[] {
  return ring.slice(0, -1).map(([lng, lat]) => ({ latitude: lat, longitude: lng }));
}

export function ringsEqual(a: number[][], b: number[][]): boolean {
  return a.length === b.length && a.every((position, i) => position[0] === b[i][0] && position[1] === b[i][1]);
}

export function isPointInPolygon(point: GeoCoordinate, polygon: GeoCoordinate[]): boolean {
  let inside = false;
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const xi = polygon[i].longitude;
    const yi = polygon[i].latitude;
    const xj = polygon[j].longitude;
    const yj = polygon[j].latitude;

    if (
      yi > point.latitude !== yj > point.latitude &&
      point.longitude < ((xj - xi) * (point.latitude - yi)) / (yj - yi) + xi
    ) {
      inside = !inside;
    }
  }
  return inside;
}
